/**
 * This constants are used to define the types of social benefits for request.
 */
export enum TypesSocialBenefits {
    BONUS = 'bonus',
    SEVERANCE = 'severance',
    SEVERANCE_INTEREST = 'severance-interest',
}
